import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  makeStyles,
  withStyles,
} from '@material-ui/core';

// Custom styles for the Stepper
const useStyles = makeStyles((theme) => ({
  stepperRoot: {
    backgroundColor: '#f5f5f5', // Stepper background color
    //padding: theme.spacing(3),
  },
  label: {
    color: 'primary',
    '&.MuiStepLabel-active': {
      color: 'red',
      fontWeight: 'bold',
    },
    '&.MuiStepLabel-completed': {
      color: 'green',
    },
  },
}));

// Custom connector styling
const ColorConnector = withStyles({
  alternativeLabel: {
    //top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: 'blue',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: 'green',
    },
  },/*
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#ccc',
    borderRadius: 1,
  },*/
})(StepConnector);

// CustomStepper component — no state, just takes props
export default function CustomStepper({ steps, activeStep, className }) {
  const classes = useStyles();

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<ColorConnector />}
      className={`${classes.stepperRoot} ${className}`}
    >
      {steps.map((step) => {
        const stepProps = {};
        const labelProps = {};
        stepProps.completed = step.state==="complete"; //step.completed;
        stepProps.active = step.state==="running"; //step.completed;
        labelProps.error =  step.state==="error"; //step.failed?step.failed: false;
        return(
        <Step key={step.id} {...stepProps}>
          <StepLabel {...labelProps} classes={{ label: classes.label }}>{step.title}</StepLabel>
        </Step>
        )
        })}
    </Stepper>
  );
}
